import instance from "../../../config/axios";
import url from "../../../constants/url";
import { apiRoutes } from "../../../constants/routes";

const qlireports = "qli-reports";

// get qli report view picklist api
export const getqlireportviewpicklist = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${qlireports}/${apiRoutes.viewpicklist}`
  );
  return res;
};

// get table data for qli
export const getTableData = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${qlireports}`, data
  );
  return res;
};